import React, { Component } from 'react';
export default class ImageViewer2 extends Component {
    onRemoveImage = () => {
        this.props.onRemove(this.props.type);
    }
    render() {
        const { props } = this;
        return (
            <div style={{ position: 'relative', backgroundColor: '#f1f1f1', maxWidth: '500px', height: '250px', backgroundImage: `url(${props.src})`, backgroundSize: '100% 100%', border: '1px solid black' }}>
                {(props.shouldRemove) ?
                    <div className='cross2'>
                        <i className="fas fa-times" style={{ fontSize: '18px', color: 'white' }} onClick={this.onRemoveImage}></i>
                    </div> : null
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/commons/ImageViewer2.js